import TarefasIndex from './Index.vue';

export const routes = [
  {
    path: 'tarefas',
    name: 'tarefas_dashboard',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: TarefasIndex,
  },
];
